import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postAnnouncementSlice = createApi(`PostAnnouncementSlice`,"POST");

const PostAnnouncementSlice = createSlice({
  name: 'PostAnnouncementSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postAnnouncementSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postAnnouncementSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postAnnouncementSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostAnnouncementSlice.reducer;